import React from "react";
import Icon from "components/Common/Icon";
import {
  EXPANSION,
  getFormattedContentType,
  getTierSet,
  getTierSetMidnight,
  getS3TierSet,
  SEASON,
} from "../../../lib/wowHelpers";
import { getWowStatic } from "hooks/wow/getStaticData";
import SubtitleAndDescription from "../../Common/SubtitleAndDescription";
import { getFormattedNames } from "../../../lib/wowHelpers";

const TierSetContainer = (props) => {
  const { className, specName, encounterType } = props;
  const { displayClassName, displaySpecName, dataClassName, dataSpecName } = getFormattedNames(className, specName);
  const tierSetData = getTierSetMidnight(className);
  const twoPieceStaticData = getWowStatic("spell", tierSetData.two_piece[specName]);
  const fourPieceStaticData = getWowStatic("spell", tierSetData.four_piece[specName]);

  return twoPieceStaticData && fourPieceStaticData ? (
    <div className="tier-set-container">
      <div className="content-section">
        <SubtitleAndDescription
          subtitle={`${displaySpecName} ${encounterType === "PvP" ? "PvP " : ""}Tier Set`}
          description={`${EXPANSION} Season ${SEASON} ${displaySpecName} ${displayClassName} ${getFormattedContentType(
            encounterType,
          )} Tier Set`}
          className="tier-set-subtitle"
        />
        <div className="tier-set-content">
          <div className="text">
            <span className="title">2-Set</span> - <Icon staticDataImg={twoPieceStaticData.img} iconSize="20px" />{" "}
            {twoPieceStaticData.description}
          </div>
          <div className="text">
            <span className="title">4-Set</span> - <Icon staticDataImg={fourPieceStaticData.img} iconSize="20px" />{" "}
            {fourPieceStaticData.description}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default TierSetContainer;
